import { GivingBack } from "../queries/aboutUsQuery";
import AboutUsDonationSection from "./aboutUsDonationSection";
import Organizations from "./organizations";
import { RichText } from "./richText";

export function GivingBackSection({
  givingBack,
  totalDonated,
}: {
  givingBack: GivingBack;
  totalDonated: number;
}) {
  return (
    <div className="flex flex-col gap-8 lg:flex-row lg:gap-16">
      <div className="lg:w-1/2">
        <div className="families-colorway mb-6 text-center">
          <span className="text-overline-2 mx-auto">GIVING BACK</span>
        </div>
        <AboutUsDonationSection
          giving={givingBack as GivingBack}
          totalDonated={totalDonated}
        />
      </div>
      <div className="lg:w-1/2">
        <div className="mb-3 italic">
          <p>Learn more about the organizations we support...</p>
        </div>
        {givingBack.organizations && (
          <div className="mt-9 lg:pr-16">
            <Organizations orgs={givingBack.organizations} />
          </div>
        )}
        {givingBack?.reachOutToUsSection && (
          <div className="mb-12 mt-10 lg:pr-16">
            <RichText content={givingBack.reachOutToUsSection}></RichText>
          </div>
        )}
      </div>
    </div>
  );
}

export default GivingBackSection;
